import { StyleSheet, Platform } from 'react-native';

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  subHeaderAfterSubTitleStyle: {
    marginLeft: 7,
  },
  headerLoadingContainerStyle: {
    marginBottom: Platform.OS === 'ios' ? 5 : 10,
  },
  subHeaderRightComponentStyle: {
    height: Platform.OS === 'ios' ? 32 : 30,
    width: Platform.OS === 'ios' ? 82 : 79,
    marginBottom: 4,
  },
  loadingSubHeaderRightComponentStyle: {
    marginBottom: 2,
    marginRight: 0.5,
  },
  subHeaderRightComponentTextStyle: {
    ...Fonts.type.bold,
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
  },
  subHeaderTitleStyle: withCurrentBillInfo => ({
    marginTop: withCurrentBillInfo ? 0 : Platform.OS === 'android' ? 8 : 13,
  }),
  firstLineLoadingStyle: {
    width: 120,
    height: 24,
    marginTop: 13.7,
  },
  lastLineLoadingStyle: {
    width: 183,
    height: 24,
    marginTop: 8,
  },
  subHeaderRightComponentContainerStyle: { marginBottom: -23 },
  updatingStyle: {
    color: Colors.mono6,
    fontSize: 14,
    lineHeight: 18,
  },
  updatingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 30,
  },
  iconStyle: {
    marginHorizontal: 8,
    opacity: 1,
  },
  rightComponentStyles: { flexDirection: 'column', marginTop: 28, marginRight: -7.5 },
});
